module.exports = __webpack_public_path__ + "static/media/about2.b8c35766.webp";